import React from "react";

const Sidebar = () => {
    return (
        <div className="w-1/3 bg-white p-4 rounded-lg shadow-md mr-4">
            <h2 className="text-xl font-semibold mb-4">Automated Portfolio: $0</h2>
            <p className="text-red-600">Ticks highlighted in red have upcoming earnings.</p>
            <p className="text-gray-500 mb-4">
                Iron Condor Zero bot is currently inactive due to overall market volatility.
            </p>

            <div className="mb-2"><h3 className="font-semibold">Wheel: $0</h3></div>
            <div className="mb-2"><h3 className="font-semibold">Trend Spread: $0</h3></div>
            <div className="mb-2"><h3 className="font-semibold">Iron Condor: $0</h3></div>
            <div className="mb-2"><h3 className="font-semibold">Iron Condor Zero: $0</h3></div>
            <div className="mb-2"><h3 className="font-semibold">King Condor: $0</h3></div>

            <div className="mt-6">
                <h4 className="font-semibold">Iron Condor Inactivity Schedule</h4>
                <ul className="list-disc list-inside">
                    <li className="mb-1">2025-04-29: Core PCE & Annual GDP Tomorrow</li>
                    <li>2025-05-06: FOMC</li>
                </ul>
            </div>
        </div>
    );
};

export default Sidebar;
